import { stepService } from '../../services'

// initial state
const state = () => ({
  steps: [],
  step: null
})

// actions
const actions = {
  async getSteps({ commit, rootState }, eventId) {
    if (!eventId) {
      eventId = rootState.event?.activeEvent?.id
    }
    await stepService.getSteps(eventId).then(
      (steps) => {
        commit('getStepsSuccess', steps)
      },
      (error) => {
        commit('getStepsFailure', error)
      }
    )
  },
  getStepsTemplate({ commit }, eventId) {
    return stepService.getStepsTemplate(eventId).then(
      (steps) => {
        commit('getStepsSuccess', steps)
        return JSON.parse(JSON.stringify(steps))
      },
      (error) => {
        commit('getStepsFailure', error)
      }
    )
  },
  getStep({ commit }, stepId) {
    stepService.getStep(stepId).then(
      (step) => {
        commit('getStepSuccess', step)
      },
      (error) => {
        commit('getStepFailure', error)
      }
    )
  },
  createStep({ commit, dispatch }, stepData) {
    stepService.createStep(stepData).then(
      (step) => {
        commit('getStepSuccess', step)
        dispatch('getSteps')
      },
      (error) => {
        commit('getStepFailure', error)
      }
    )
  },
  updateStep({ commit, dispatch }, { stepId, stepData }) {
    stepService.updateStep(stepId, stepData).then(
      (step) => {
        commit('getStepSuccess', step)
        dispatch('getSteps')
      },
      (error) => {
        commit('getStepFailure', error)
      }
    )
  },
  deleteStep({ commit, dispatch }, stepId) {
    stepService.deleteStep(stepId).then(
      (step) => {
        commit('getStepSuccess', step)
        dispatch('getSteps')
      },
      (error) => {
        commit('getStepFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getStepsSuccess(state, steps) {
    state.steps = steps
  },
  getStepSuccess(state, step) {
    state.step = step
  },
  getStepsFailure(state, error) {
    console.log(state, error)
  },
  getStepFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
